export class TotalizeRepository {
    private httpService: IHttpService
    constructor(instance: IHttpService) {
        this.httpService = instance;
    }

    async getTotalize({employee_id, start_date, end_date}: {employee_id: number, start_date: string, end_date: string}): Promise<any[]> {
        try {
            const response = await this.httpService.get<TKResponse<any[]>>('/result_totalize', {
                params: {
                    employee_id: employee_id,
                    start_date: start_date,
                    end_date: end_date
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error al obtener los totalizes:', error);
            throw error;
        }
    }

}